import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

import useStickyState from '../utils/useStickyState';

export const tokenContext = createContext();

const TokenProvider = (props) => {
  const [token,setToken]=useStickyState(null,"token",{sessionOnly:true});
  const dropAdmin= () => { setToken(null);}
  const invalidateToken = () => { setToken("token");}
	const [lastAdmin,setLastAdmin]=useState('/adminresults');

	const pathName=useLocation().pathname;
	if (pathName.match(/^\/admin.+/) && lastAdmin!==pathName)
		setLastAdmin(pathName);
	else if (!pathName.match(/^\/admin/) && lastAdmin!=='/adminresults')
		setLastAdmin('/adminresults');

	return(
		<tokenContext.Provider value={{token,setToken,dropAdmin,invalidateToken,lastAdmin}}>
			{props.children}
		</tokenContext.Provider>
	);
}

export default TokenProvider;
